import {Room} from "colyseus.js";
import {KitchenScene} from "./scene";
import {Messenger} from "./messenger";
import {KitchenState} from "../model/state";
import {mainLogger} from "./client_logger";
import {syncSpritesOnObjects} from "./object_model_sync";
import {getAuthToken} from "./auth";


const logger = mainLogger.child({label: 'client.synchronizer'})


export type Joinable = { joinOrCreate<T>(key: string, options?: any), joinById<T>(roomId: string, options?: any) }

export class Synchroniser {

    messenger: Messenger
    room: Room<KitchenState>
    sessionId: string;
    private scene: KitchenScene;

    async bringSceneToAServerRoom(scene: KitchenScene, client: Joinable, roomId?: string, playerName?: string) {
        const params = new URLSearchParams(window.location.search);
        const targetRoomId = roomId || params.get('roomId');

        // Fetch a fresh token at join time — Clerk tokens expire in 60s.
        // The token is sent in the HTTP POST body of the Colyseus matchmake request (not in a URL
        // query string), so it is not exposed in server logs or browser history. Browser WebSocket
        // API does not allow setting custom headers, making this the secure approach available.
        const token = await getAuthToken();
        const joinOptions = {token, ...(playerName ? {playerName} : {})};

        const roomPromise = targetRoomId
            ? client.joinById<KitchenState>(targetRoomId, joinOptions)
            : client.joinOrCreate<KitchenState>("kitchen", joinOptions);

        roomPromise.then((room) => {
            logger.info(`Room joined successfully: ${room.sessionId}`);
            // @ts-ignore
            this.connectToRoom(room, scene);
        }).catch((error) => {
            logger.error(`Failed to join room: ${error}`);
        });
    }

    connectToRoom(room: Room<KitchenState>, scene: KitchenScene) {
        this.room = room
        this.sessionId = room.sessionId
        this.scene = scene
        scene.setSessionId(this.sessionId)
        this.activateRoomSceneSynchronisation(room, scene);
        this.connectMessenger(room);
        scene.events.emit('connected')
    }

    private activateRoomSceneSynchronisation(room: Room<KitchenState>, scene: KitchenScene) {
        syncSpritesOnObjects(room.state.cooks, scene.cookObjects);
        syncSpritesOnObjects(room.state.ingredients, scene.ingredientObjects);
        syncSpritesOnObjects(room.state.baskets, scene.basketObjects);
        syncSpritesOnObjects(room.state.stations, scene.stationObjects);
    }

    connectMessenger(room: Room<KitchenState>) {
        this.messenger = new Messenger(room)
    }

    connected(): boolean {
        return this.messenger != undefined
    }
}
